module.exports = __webpack_public_path__ + "img/302.264675da.png";